import React from "react";
import clsx from "clsx";
import styles from "./styles.module.css";
import { NavLink } from "react-router-dom";
import { ReactComponent as LeftChevron } from "../../assets/left-chevron-icon.svg"
import { NAVIGATION_ROUTES } from "../../constant";

interface ClickableItemProps {
  link?: string;
  heading?: string;
  subHeading?: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  type?: string;
}

const ClickableItemBox: React.FC<ClickableItemProps> = ({ link = "", heading, subHeading, icon, onClick, type }) => {
  return (
    <NavLink to={{ pathname: type === "EXTERNAL_LINK" ? NAVIGATION_ROUTES.EXTERNAL_LINKS : link }}
      state={{ url: link }} onClick={onClick} className={clsx(styles.clickableItemContainer)}>
      <div className={clsx(styles.itemBlock)}>
        <div className={clsx(styles.iconBox)}>
          {icon && <div className={styles.icon}>{icon}</div>}
        </div>
        <div className={clsx(styles.contentBox)}>
          {heading && <div className={clsx(styles.heading, "fontSizeSm14 fontWeightBold fontColorBlack")}>{heading}</div>}
          {subHeading && <div className={clsx(styles.subHeading, "fontSizeSm12 fontWeightRegular fontColor666")}>{subHeading}</div>}
        </div>
        <div className={clsx(styles.navigationIconBox, "rotate180")}>
          <LeftChevron />
        </div>
      </div>
    </NavLink>
  );
};

export default ClickableItemBox;
